import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';

const marketAccordionItemCss = "button{all:unset;display:flex;justify-content:space-between;align-items:center;width:100%;color:var(--accordion-normal-state-content-color);cursor:pointer}button:focus-visible{outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color)}button:hover{color:var(--accordion-hover-state-content-color)}button:active{color:var(--accordion-pressed-state-content-color)}:host([disabled]) button{color:var(--accordion-disabled-state-content-color);cursor:not-allowed;pointer-events:none}svg{transition-duration:300ms}:host([expanded]) svg{transform:rotate(-180deg)}h2{margin:0;font-weight:var(--accordion-heading-30-variant-text-weight);font-size:var(--accordion-heading-30-variant-text-size);font-family:var(--accordion-heading-30-variant-text-font-family)}h2 button{padding:var(--accordion-heading-30-variant-vertical-padding)\n      var(--accordion-heading-30-variant-horizontal-padding);box-shadow:inset\n      0\n      calc(var(--accordion-heading-30-variant-separator-size) * -1)\n      0\n      var(--accordion-heading-30-variant-separator-color)}h3{margin:0;font-weight:var(--accordion-heading-20-variant-text-weight);font-size:var(--accordion-heading-20-variant-text-size);font-family:var(--accordion-heading-20-variant-text-font-family)}h3 button{padding:var(--accordion-heading-20-variant-vertical-padding)\n      var(--accordion-heading-20-variant-horizontal-padding);box-shadow:inset\n      0\n      calc(var(--accordion-heading-20-variant-separator-size) * -1)\n      0\n      var(--accordion-heading-20-variant-separator-color)}h4{margin:0;font-weight:var(--accordion-heading-10-variant-text-weight);font-size:var(--accordion-heading-10-variant-text-size);font-family:var(--accordion-heading-10-variant-text-font-family)}h4 button{padding:var(--accordion-heading-10-variant-vertical-padding)\n      var(--accordion-heading-10-variant-horizontal-padding);box-shadow:inset\n      0\n      calc(var(--accordion-heading-10-variant-separator-size) * -1)\n      0\n      var(--accordion-heading-10-variant-separator-color)}:host([size='medium']) svg{width:20px;height:20px}:host([size='small']) svg{width:16px;height:16px}";

const sizeToHeadingType = {
  large: '2',
  medium: '3',
  small: '4',
};
const MarketAccordionItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketAccordionItemExpandedChange = createEvent(this, "marketAccordionItemExpandedChange", 7);
    this.name = undefined;
    this.expanded = false;
    this.disabled = false;
    this.size = 'medium';
    this.customTrigger = undefined;
  }
  marketAccordionToggleHandler(e) {
    e.stopPropagation();
    this.setExpanded(!this.expanded);
  }
  /**
   * Used to set the "open" state of the accordion.
   */
  setExpanded(newExpanded) {
    const oldExpanded = this.expanded;
    if (newExpanded !== oldExpanded) {
      const { defaultPrevented } = this.marketAccordionItemExpandedChange.emit({
        expanded: newExpanded,
      });
      if (!defaultPrevented) {
        this.expanded = newExpanded;
        if (this.customTrigger) {
          this.customTrigger.expanded = newExpanded;
        }
      }
    }
    return Promise.resolve();
  }
  /**
   * Sets `disabled` state. Allows external elements to programmatically trigger disabled styling.
   */
  setDisabled(value) {
    this.disabled = value;
    return Promise.resolve();
  }
  componentWillLoad() {
    this.customTrigger = this.el.querySelector('[slot="custom-trigger"]');
    if (this.customTrigger) {
      this.customTrigger.expanded = this.expanded;
    }
  }
  render() {
    const Heading = `h${sizeToHeadingType[this.size]}`;
    return (h(Host, { class: "market-accordion-item" }, this.customTrigger ? (h("slot", { name: "custom-trigger" })) : (h(Heading, null, h("button", { id: `${this.name}__button`, type: "button", "aria-expanded": this.expanded, "aria-controls": `${this.name}__content`, "aria-disabled": this.disabled, disabled: this.disabled, onClick: () => this.setExpanded(!this.expanded) }, h("slot", { name: "label" }), h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, h("path", { fill: "currentColor", d: "M13.06 17.56a1.5 1.5 0 0 1-2.12 0l-9-9 2.12-2.12L12 14.378l7.94-7.94 2.12 2.122-9 9Z" }))))), this.expanded && (h("div", { id: `${this.name}__content`, role: "region", "aria-labelledby": `${this.name}__button` }, h("slot", null)))));
  }
  get el() { return getElement(this); }
};
MarketAccordionItem.style = marketAccordionItemCss;

export { MarketAccordionItem as market_accordion_item };
